import { getEpicDashboardData, getLetters, getBffDashboard, dcjSelfOrderApi, dcjSelfOrderOptOut } from "../api/epicApi";
import { setMembershipNotificationResponse } from "../api/membershipsApi";
import { getVideoVisitUrl } from "../api/portalApi";
import { dismissDiscoveryTile, unDismissDiscoveryTiles} from "../api/healthSourceApi";
import * as types from "../constants/actionTypes";
import { call, put, select, takeLatest } from "redux-saga/effects";
import { indexOf } from 'lodash';
import * as d from "../reducers/domainReducer";
import Cookies from "cookies-js";
import { getDomain } from "../helpers/Tools";
import { log, logAPI } from "../api/andyliticsApi";
import * as Tools from "../helpers/Tools";

export default function* dashboardSaga() {
    yield takeLatest([types.LOAD_DASHBOARD_START], handleDashStart);
    yield takeLatest([types.USER_AUTHENTICATE_SUCCESS], handleUserAuthenticateSuccess);
    yield takeLatest([types.LOAD_BFF_DASHBOARD_START], loadBffDashboard);
    yield takeLatest(types.SWITCH_USER_SAGA, handleUserSwitch);
    yield takeLatest([types.GET_EPIC_LETTERS], getEpicLetters);
    //yield takeLatest([types.DCJ_SELF_ORDER], dcjSelfOrder);
    //yield takeLatest([types.DCJ_SELF_ORDER_OPTOUT], handleDcjSelfOrderOptOut);
    yield takeLatest([types.SET_MEMBERSHIP_NOTI_RESPONSE], setMembershipNotiResponse);
    yield takeLatest([types.DISCOVER_TILE_DISMISS], handleDismissDiscoverTile);
    yield takeLatest([types.DISCOVER_TILE_UNDISMISS], handleUnDismissAllDiscoverTiles);
}

function* handleUnDismissAllDiscoverTiles(payload) {
    const token = payload.token;
    yield call(unDismissDiscoveryTiles, token);
}

function* handleDismissDiscoverTile(payload) {
    const tile = payload.tile;
    const token = payload.token;
    console.info(`dashboardSaga handleDismissDiscoverTile`, token, tile);
    yield call(dismissDiscoveryTile, token, tile);
    yield put({ type: types.DISCOVER_TILE_DISMISS_SUCCESS, tile: tile });

}

function* handleDashStart(payload) {
    const start = new Date();
    try {
        //debugger;
        yield handleCommonResponse(payload);
        yield loadBffDashboard(payload);
        //yield put({
        //    type: types.GET_EPIC_LETTERS
        //});
        logAPI("MBHWeb.Saga.Dashboard.Get", start, null);
    }
    catch (err) {
        console.error(err);
        logAPI("MBHWeb.Saga.Dashboard.Get.Failure", start, null, err);
        //debugger;
        // Microsoft Edge throws TypeMismatchError when fetch returns 401
        if (err && (err.status === 401 || err.message === 'TypeMismatchError')) {
            console.log("VERIFY_LOGIN");
            yield put({ type: types.VERIFY_LOGIN, errorCode: 401 });
        }
        else {
            yield put({ type: types.AJAX_CALL_ERROR, error: err });
            yield put({ type: types.LOAD_DASHBOARD_ERROR, error: err });
        }
        if (payload.callback) {
            payload.callback(null);
        }
    }
}

function* handleUserAuthenticateSuccess(payload) {
    const start = new Date();
    try {
        try {
       //     yield handleCommonResponse(payload);
        } catch (e) {
            console.error(e);
        }
        // yield loadBffDashboard();
        //yield put({
        //    type: types.GET_EPIC_LETTERS
        //});
        //debugger;
        if (Cookies.get("BSWPROXY") === null) {
            //debugger;
            Cookies.set('BSWPROXY', "", { path: '/', domain: sDomain });
        }
    }
    catch (err) {
        console.error(err);
    }
}

function* handleUserSwitch(payload) {
    const start = new Date();
    try {

        //debugger;
        const currentUser = payload.user;
        const memberships = yield select((state) => state.memberships);
        try {
            //debugger;
            if (currentUser) {
                const sDomain = getDomain();
                console.log('dashboadrdSaga: setting cookie BSWPROXY... old:', Cookies.get('BSWPROXY'), 'new:', currentUser.relationshipId);
                yield put({ type: types.COOKIE_BSWPROXY_START });
                if (currentUser.relationshipId) {
                    Cookies.set('BSWPROXY', currentUser.relationshipId, { path: '/', domain: sDomain });
                }
                else {
                    Cookies.set('BSWPROXY', "", { path: '/', domain: sDomain });
                }
                //yield put({
                //    type: types.GET_EPIC_LETTERS, user: currentUser
                //});
                yield put({ type: types.COOKIE_BSWPROXY_SUCCESS });
            }
        }
        catch (E) {
            //debugger;
            console.error(e);
        }

        yield handleCommonResponse(payload);
        yield loadBffDashboard(payload);

        if (payload && payload.isSeeAllSelected) {
            yield put({ type: types.LOAD_DASHBOARD_SEE_ALL_VIEW });
        } else if (payload && payload.isSeeAllSelected === false) {
            yield put({ type: types.RESET_DASHBOARD_SEE_ALL_VIEW });
        } else {
            yield put({ type: types.RESET_DASHBOARD_SEE_ALL_VIEW });
        }

        if (window && window.serverData.data.enablePatientPhoto && currentUser.myChartId) {
            yield put({ type: types.PATIENT_PHOTO_START });
        }

        if (memberships.switchingProxyUser && memberships.switchUserPayload) {
            let newPayload = { ...memberships.switchUserPayload }
            newPayload.type = types.SWITCH_USER_REDUCER
            yield put(newPayload);
        }

    }
    catch (err) {
        console.error(err);
    }
}


function* handleCommonResponse(payload) {
    try {
        const domain = yield select((state) => state.domain);
        const memberships = yield select((state) => state.memberships);
        const currentUser = payload && payload.user ? payload.user : null;
        const externalId = currentUser ? currentUser.externalId : domain.cu && domain.cu.ei ? domain.cu.ei : null;
        if (domain && domain.un && domain.hm) {
            let response = null;
            // the check here fixes bug# 38507; the issue happens when we:
            // switch user from myChartUser1 to pharmacyUser1, and then to myChartUser2,
            // dashboard was loaded  twice - 1st time for myChartUser2, and 2nd time for myChartUser1 (which is avoided by the check here)
            if (payload.type !== 'LOAD_DASHBOARD_START' || !memberships.switchingProxyUser) {
                response = yield call(getEpicDashboardData, domain.un, domain.t, externalId);
                yield put({ type: types.LOAD_DASHBOARD_SUCCESS, dashBoardData: response, isWaiting: false });
            }

            if (payload.callback) {
                payload.callback(response);
            }
        }
    }
    catch (err) {
        console.error(err);
        throw err;
    }
}

function* getEpicLetters(payload) {
    const start = new Date();

    try {
        const domain = yield select((state) => state.domain);
        const memberships = yield select((state) => state.memberships);
        const currentUser = payload && payload.user ? payload.user : null;
        const externalId = currentUser ? currentUser.externalId : domain.cu && domain.cu.ei ? domain.cu.ei : null;
        if (domain && domain.un && domain.hm) {
            const lettersData = yield call(getLetters, domain.un, domain.t, domain.mc, externalId);
            logAPI("MBHWeb.Saga.DashBoard.GetLetters.Success", start, null);
            yield put({ type: types.GET_EPIC_LETTERS_SUCCESS, letters: lettersData });

        }
    } catch (err) {
        yield put({ type: types.GET_EPIC_LETTERS_FAILURE });
        console.error(err);
        logAPI("MBHWeb.Saga.DashBoard.GetLetters.Failure", start, null, JSON.stringify(err));
    }
}


//loadBffDashboard to handle video visit appointment info, xealthmessages, and membership change notifications                
function* loadBffDashboard(payload) {
    const start = new Date();
    try {
        const domain = yield select((state) => state.domain);
        const currentUser = payload && payload.user ? payload.user : domain && domain.cu ? domain.cu : null;
        const memberships = yield select((state) => state.memberships);
        const session = yield select((state) => state.session);
        const dashboard = yield select((state) => state.dashboard);

        if (domain && domain.pl && domain.pl.length === 0) {
            yield put({ type: types.RESET_DASHBOARD_SEE_ALL_VIEW });
        }

        let dashboardShowActCode = payload && payload.isSeeAllSelected ? "MBHWeb.Saga.Dashboard.Show.SeeAllView" : "MBHWeb.Saga.Dashboard.Show.CurrentUser";
        logAPI(dashboardShowActCode, start, null, currentUser);

        if (domain && domain.t && domain.hm) {
            yield put({ type: types.LOAD_BFF_DASHBOARD_PENDING });
            //Reset Video Visit links.
            yield put({ type: types.GET_VIDEO_VISIT_LINK_RESET });
            //BffDashboard has xealthMessages and videovisit appointment info for primary user and its proxies.            
            const dashboardResponse = yield Tools.safeCall(getBffDashboard, domain.t);

            let response = null;

            //debugger;
            if (dashboardResponse && dashboardResponse.err) {
                yield put({ type: types.LOAD_BFF_DASHBOARD_FAILURE, bffDashboardData: null });
                logAPI("MBHWeb.Saga.DashBoard.BffDashboard.Failure", start, null, JSON.stringify(dashboardResponse));
            }
            else {
                logAPI("MBHWeb.Saga.DashBoard.BffDashboard.Success", start, null, dashboardResponse);
                response = dashboardResponse && dashboardResponse.result ? dashboardResponse.result : null;

                if (response) {
                    response.isMyChartInActive = response && response.myChartStatus && response.myChartStatus.myChartStatusText ? (response.myChartStatus.myChartStatusText.toLowerCase() === "inactivated" || response.myChartStatus.myChartStatusText.toLowerCase() === "patient_declined") ? true : false : false;

                    if (session.serverData?.enableV2MembershipLinking) {
                        response.filteredMembershipNotifications = null;
                        if (response.membershipNotifications && response.membershipNotifications.length > 0) {
                            let filteredMsgs = response.membershipNotifications.reduce((acc, noti) => {
                                if (!noti.userResponseDateTimeUtc) {
                                    let notiMessage = {
                                        subject: noti.subject,
                                        message: noti.message,
                                        responseOne: noti.responseOptions[0],
                                        id: noti.id
                                    }
                                    acc.push(notiMessage);
                                }
                                return acc;
                            }, [])

                            if (filteredMsgs.length > 0) {
                                response.filteredMembershipNotifications = filteredMsgs[0];
                            }
                        }
                    }

                    response.visits = [];//payload && payload.isAllSelected ? response.visits : response.visits.filter(visit => (currentUser && currentUser.epi && visit.patientExternalId === currentUser.epi));
                    response.currentUser = null;
                    response.showCareCompanion = false;
                    response.avs = [];
                    if (response.patients) {
                        const currentUserExternalId = currentUser ? currentUser.ei ? currentUser.ei : currentUser.externalId ? currentUser.externalId : null : null;

                        response.patients = response.patients.map(pat => {
                            const patientId = pat.patientIds.find((v, i) => { return v.idType && v.idType.toLowerCase() === "external" })
                            pat.patientExternalId = '';
                            if (patientId) {
                                pat.patientExternalId = patientId.id;
                            }
                            return pat;
                        });

                        for (let i = 0; i < response.patients.length; i++) {
                            let patientInfo = response.patients[i];
                            //check carecarecompanion for seeallview, if any one of the patients found carecompanion.
                            if (patientInfo && patientInfo.careCompanion && patientInfo.careCompanion.isCareCompanion) {
                                response.showCareCompanion = true;
                            }

                            //Load Visits and AVS
                            if (((payload && payload.isSeeAllSelected) || (currentUserExternalId && currentUserExternalId === patientInfo.patientExternalId))) {
                                //Load Visits
                                if (patientInfo.visits && patientInfo.visits.visits && patientInfo.visits.visits.length > 0) {
                                    patientInfo.visits.visits.sort((a, b) => {
                                        const dtA = new Date(a.appointmentDateTime);
                                        const dtB = new Date(b.appointmentDateTime);
                                        return dtA > dtB ? 1 : -1;
                                    });
                                    let visit = patientInfo.visits.visits[0];
                                    visit.patientName = patientInfo.patientName;
                                    response.visits.push(visit);
                                }

                                //Load AVS
                                if (patientInfo.pastAppointments && patientInfo.pastAppointments.appointments && patientInfo.pastAppointments.appointments.length > 0) {
                                    let currentAvs = patientInfo.pastAppointments.appointments[0];
                                    currentAvs.patientName = patientInfo.patientName;
                                    currentAvs.patientExternalId = patientInfo && patientInfo.patientExternalId ? patientInfo.patientExternalId : '';
                                    response.avs.push(currentAvs);
                                }

                            }
                            if (currentUserExternalId && currentUserExternalId === patientInfo.patientExternalId) {
                                response.currentUser = patientInfo
                            }
                        }
                    }
                    yield put({ type: types.LOAD_BFF_DASHBOARD_SUCCESS, bffDashboardData: response });
                } else {
                    yield put({ type: types.LOAD_BFF_DASHBOARD_FAILURE, bffDashboardData: null });
                }
            }

            if (typeof payload !== 'undefined' && payload && payload.callback) {
                payload.callback(response);
            }


            //Don't wait for dashboard to load, added this section here.
            if (response && response.visits && session && session.serverData?.visitTypesForMsTeams) {
                for (let j = 0; j < response.visits.length; j++) {
                    const visit = response.visits[j];
                    const visitTypeIDs = visit ? visit.visitTypeIDs.filter(id => id.idType && id.idType.toLowerCase() === 'internal') : null;
                    const visitTypeID = visitTypeIDs && visitTypeIDs.length > -1 ? visitTypeIDs[0].id : null;
                    const visitTypesForMsTeams = session.serverData?.visitTypesForMsTeams.replace(/ /g, '').split(',');
                    if (visit && visit.csnIdOfAppointment && visitTypeID && visitTypesForMsTeams && visitTypesForMsTeams.indexOf(visitTypeID.trim()) != -1 && visit.eCheckInStatus.toUpperCase() === 'COMPLETED') {
                        const csnIdOfAppointment = visit.csnIdOfAppointment;
                        yield put({ type: types.GET_VIDEO_VISIT_LINK, csn: csnIdOfAppointment });
                        try {
                            let videoVisitLink = yield call(getVideoVisitUrl, domain.t, domain.un, csnIdOfAppointment);
                            videoVisitLink.csn = csnIdOfAppointment;
                            logAPI("MBHWeb.Saga.DashBoard.GetVideoVisitLink.Success", start, null, videoVisitLink);
                            yield put({ type: types.GET_VIDEO_VISIT_LINK_SUCCESS, videoVisitLink });
                        } catch (error) {
                            yield put({ type: types.GET_VIDEO_VISIT_LINK_FAILURE, error, csnIdOfAppointment });
                            console.error(error);
                            logAPI("MBHWeb.Saga.DashBoard.GetVideoVisitLink.Failure", start, null, JSON.stringify(error));
                        }
                    }
                }
            } else {
                yield put({ type: types.GET_VIDEO_VISIT_LINK_RESET });
            }
        }

        if (memberships.switchingProxyUser && memberships.switchUserPayload) {
            let newPayload = { ...memberships.switchUserPayload }
            newPayload.type = types.SWITCH_USER_REDUCER
            yield put(newPayload);
        }
    }
    catch (err) {
        yield put({ type: types.LOAD_BFF_DASHBOARD_FAILURE });
        try {
            const memberships = yield select((state) => state.memberships);
            if (memberships.switchingProxyUser && memberships.switchUserPayload) {
                let newPayload = { ...memberships.switchUserPayload }
                newPayload.type = types.SWITCH_USER_REDUCER
                yield put(newPayload);
            }
            if (payload && payload.callback) {
                payload.callback(err);
            }
        } catch (err1) {
            console.log(err1);
        }
        console.error(err);
        logAPI("MBHWeb.Saga.DashBoard.BffDashboard.Failure", start, null, JSON.stringify(err));
    }
}

function* setMembershipNotiResponse(payload, callBack = null) {
    const start = new Date();
    try {
        const domain = yield select((state) => state.domain);
        const sso = yield select((state) => state.sso);
        let body = {
            response: payload.response,
            id: payload.id
        };
        yield call(setMembershipNotificationResponse, domain.t, body);
        logAPI("MBHWeb.Saga.DashBoard.SetMembershipNotiResponse.Success", start, null);
        if (callBack) {
            callback();
        }
    } catch (err) {
        console.error(err);
        logAPI("MBHWeb.Saga.DashBoard.SetMembershipNotiResponse.Failure", start, null, JSON.stringify(err));
    }
}


//function* dcjSelfOrder(payload) {
//    const start = new Date();
//    try {
//        const { token, myChartId, goalProgramId } = payload;
//        if (token && myChartId && goalProgramId) {
//            yield put({ type: types.DCJ_SELF_ORDER_PENDING });
//            const response = yield call(dcjSelfOrderApi, token, myChartId, goalProgramId);

//            if (response >= 200 && response < 300) {    // there's some confusion over whether to expect a 200 or a 204. Just accept anything 2xx.
//                logAPI("MBHWeb.Saga.Dashboard.DcjSelfOrder.Success", start, null);
//                yield put({ type: types.DCJ_SELF_ORDER_SUCCESS });
//                yield loadBffDashboard();
//            }
//            else {
//                yield put({ type: types.DCJ_SELF_ORDER_FAILURE });
//                logAPI("MBHWeb.Saga.Dashboard.DcjSelfOrder.Failure", start, null, response);
//            }
//        }
//    } catch (err) {
//        yield put({ type: types.DCJ_SELF_ORDER_FAILURE });
//        logAPI("MBHWeb.Saga.Dashboard.DcjSelfOrder.Failure", start, null, JSON.stringify(err));
//    }
//}

//function* handleDcjSelfOrderOptOut(payload) {
//    const start = new Date();
//    try {
//        const { token, myChartId, goalProgramId } = payload;
//        if (token && myChartId && goalProgramId) {
//            yield put({ type: types.DCJ_SELF_ORDER_OPTOUT_PENDING });
//            const response = yield call(dcjSelfOrderOptOut, token, myChartId, goalProgramId);
//            if (response === 204) {
//                logAPI("MBHWeb.Saga.Dashboard.DcjSelfOrderOptOut.Success", start, null);
//                yield put({ type: types.DCJ_SELF_ORDER_OPTOUT_SUCCESS });
//                yield loadBffDashboard();
//            }
//            else {
//                yield put({ type: types.DCJ_SELF_ORDER_OPTOUT_FAILURE });
//                //yield put({ type: types.DCJ_SELF_ORDER_OPTOUT_SUCCESS });

//                logAPI("MBHWeb.Saga.Dashboard.DcjSelfOrderOptOut.Failure", start, null, response);
//            }
//        }
//    } catch (err) {
//        yield put({ type: types.DCJ_SELF_ORDER_OPTOUT_FAILURE });
//        // yield put({ type: types.DCJ_SELF_ORDER_OPTOUT_SUCCESS });
//        logAPI("MBHWeb.Saga.Dashboard.DcjSelfOrderOptOut.Failure", start, null, JSON.stringify(err));
//    }
//}

//function* handleDashAction(payload) {
//    const start = new Date();
//    try {
//        const domain = yield select((state) => state.domain);
//        //const userDetails = yield select((state) => state.sso.userDetails);

//        if (domain && domain.un && domain.hm) {
//            //debugger;
//            const currentUser = d.hydrateProxyUser(yield select(state => state.domain.cu));
//            ////try {
//            ////    if (currentUser) {
//            ////        console.log('dashboadrdSaga: setting cookie BSWPROXY... old:', Cookies.get('BSWPROXY'), 'new:', currentUser.relationshipId);
//            ////        const sDomain = getDomain();
//            ////        yield put({ type: types.COOKIE_BSWPROXY_START });
//            ////        if (currentUser.relationshipId) {
//            ////            Cookies.set('BSWPROXY', currentUser.relationshipId, { path: '/', domain: sDomain });
//            ////        }
//            ////        else {
//            ////            Cookies.set('BSWPROXY', "", { path: '/', domain: sDomain });
//            ////        }
//            ////        yield put({ type: types.COOKIE_BSWPROXY_SUCCESS });
//            ////    }
//            ////}
//            ////catch (E) {
//            ////    //debugger;
//            ////    console.error(e);
//            ////}

//            const response = yield call(getEpicDashboardData, domain.un, domain.t, currentUser ? currentUser.externalId : null);
//            yield put({ type: types.LOAD_DASHBOARD_SUCCESS, dashBoardData: response, isWaiting: false });
//            logAPI("MBHWeb.Saga.Dashboard.Get", start, null);
//            if (payload.callback) {
//                payload.callback(response);
//            }
//        }
//        if (payload.type === types.SWITCH_USER_SAGA) {
//            payload.type = types.SWITCH_USER_REDUCER;
//            yield put(payload);
//        }
//    }
//    catch (response) {
//        console.error(response);
//        logAPI("MBHWeb.Saga.Dashboard.Get.Failure", start, null, response);
//        //debugger;
//        // Microsoft Edge throws TypeMismatchError when fetch returns 401
//        if (response.status === 401 || response.message === 'TypeMismatchError') {
//            console.log("VERIFY_LOGIN");
//            yield put({ type: types.VERIFY_LOGIN, errorCode: 401 });
//        }
//        else {
//            yield put({ type: types.AJAX_CALL_ERROR, error: response });
//            yield put({ type: types.LOAD_DASHBOARD_ERROR, error: response });
//        }
//        if (payload.callback) {
//            payload.callback(null);
//        }
//    }
//}
